import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { API_DOMAIN } from './globals'; // Import the global domain name

function WM() {

    const [UserType, setUserType] = useState("");
    const [UserName, setUserName] = useState("");

    const [Team1Amt, setTeam1Amt] = useState("");
    const [Team2Amt, setTeam2Amt] = useState("");
    const [Team3Amt, setTeam3Amt] = useState("");

    const [WMBets, setWMBets] = useState([]);
    const [LastResult, setLastResult] = useState([]);
    const [BetChk, setBetChk] = useState(true);

    const handleCancelClick = () => {
        document.getElementById("betSlipBoxSession").style.display = "none";
        document.getElementById("betSlipBoxSessionMob").style.display = "none";
    };

    const handlePlaceBet = () => {
        PlaceWMBet();
    };

    function getWMResult() {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getWMResult.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    setLastResult(data.data);
                    var UsedCoins = data.data[0].UsedCoins;
                    $("#TotalCoins").html(data.data[0].TotalCoins - data.data[0].UsedCoins);
                    $("#UsedCoins").html(UsedCoins);
                    $("#TotalCoinsMob").html(data.data[0].TotalCoins - data.data[0].UsedCoins);
                    $("#UsedCoinsMob").html(UsedCoins);
                }
            })
            .catch(err => {

            });
    }

    function PlaceWMBet() {
        const matchMinAmount = parseFloat(document.getElementById("MatchMinAmount").value);
        const matchMaxAmount = parseFloat(document.getElementById("MatchMaxAmount").value);
        const notificationType = "Match Bet";
        let response = "";

        const windowWidth = window.innerWidth;
        let betAmount = windowWidth >= 500
            ? parseFloat(document.getElementById("MatchAmount").value)
            : parseFloat(document.getElementById("MatchAmountMob").value);

        const modal = document.getElementById("myModal");
        if (modal) modal.style.display = "none"; // Hide the modal

        if (!isNaN(betAmount)) {
            if (betAmount >= matchMinAmount && betAmount <= matchMaxAmount) {
                const betRate = document.getElementById("MatchRate").value;
                const betMode = document.getElementById("MatchBetChk").value;
                const betTeam = document.getElementById("MatchTeam").value;
                const matchCode = document.getElementById("RoundID").innerHTML;
                const matchBetChk = document.getElementById("MatchBetChk").value;
                const matchType = "Lucky7";
                const userType = document.getElementById("UserType").value;
                const userName = document.getElementById("UserName").value;

                const teamKRate = document.getElementById("TeamKRate").value;
                const teamLRate = document.getElementById("TeamLRate").value;
                const bst = document.getElementById("ServerTime_Select").value;
                const bpt = document.getElementById("ServerTime_Formatted").value;
                const id = document.getElementById("BetTeamindex").value;

                //console.log("id="+id+", TeamKRate="+$("#TeamKRate").val()+", KRate="+$("#KRate"+id).val()+", TeamLRate="+$("#TeamLRate").val()+", "+$("#LRate"+id).val());

                if(($("#TeamKRate").val()==$("#KRate"+id).attr("rt"))) {
                    const url = `${API_DOMAIN}/PlaceWMBet.php?BetRate=${betRate}&BetAmount=${betAmount}&BetMode=${betMode}&BetTeam=${betTeam}&MatchCode=${matchCode}&MatchBetChk=${matchBetChk}&MatchType=${matchType}&BetType=${"Match Bet"}&TeamKRate=${teamKRate}&TeamLRate=${teamLRate}&BST=${bst}&BPT=${bpt}&ut=${userType}&un=${userName}`;

                    fetch(url, {
                        method: 'GET',
                        credentials: 'include', // Equivalent to withCredentials:true
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.Status === "Success") {
                                document.getElementById("TotalCoins").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoins").innerHTML = data.UsedCoins;

                                document.getElementById("TotalCoinsMob").innerHTML = data.TotalCoins - data.UsedCoins;
                                document.getElementById("UsedCoinsMob").innerHTML = data.UsedCoins;

                                sessionStorage.setItem('Coins', data.TotalCoins);
                                sessionStorage.setItem('Exposure', data.UsedCoins);

                                setTeam1Amt(data.Team1Amt);
                                setTeam2Amt(data.Team2Amt);
                                setTeam3Amt(data.Team3Amt);
                                
                                setWMBets((prevBets) => [data.BetDetails[0], ...prevBets]);

                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content success">
                                                <i class="component-icon-wrap icon-success"></i>
                                                <p>Bet Successful</p>
                                            </div>
                                        </div>`;
                            } else {
                                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                            <div class="message-content error">
                                                <i class="component-icon-wrap icon-error"></i>
                                                <p>${data.Message}</p>
                                            </div>
                                        </div>`;
                            }
                            document.getElementById("BetResponse").innerHTML = response;
                            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                            ;
                            $("#betSlipBoxSession").css('display', 'none');
                            $("#betSlipBoxSessionMob").css('display', 'none');
                        });
                } else {
                    response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                <div class="message-content error">
                                    <i class="component-icon-wrap icon-error"></i>
                                    <p>Bet Rejected. Rate Has Been Changed</p>
                                </div>
                            </div>`;
                    document.getElementById("BetResponse").innerHTML = response
                    setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
                }
            } else {
                response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                            <div class="message-content error">
                                <i class="component-icon-wrap icon-error"></i>
                                <p>${betAmount < matchMinAmount ? `Minimum Bet Amount is ${matchMinAmount}` : `Maximum Bet Amount is ${matchMaxAmount}`}</p>
                            </div>
                        </div>`;
                document.getElementById("BetResponse").innerHTML = response;
                setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
            }
        } else {
            response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p>Invalid Amount ${betAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = response;
            setTimeout(() => { document.getElementById("BetResponse").innerHTML = ""; }, 3000);
        }
    }

    $(document).on('click', '.casinoBet', function (e) {
        //fadeOutReset();
        console.log("BetChk=" + BetChk);
        if (BetChk == true) {
            var rateVal = $(this).attr('rt');
            var betOn = $(this).attr('betOn');
            var gameId = $("#market_id").val();
            var betType = $(this).attr('bt');

            console.log("rateVal=" + rateVal + ", betType=" + betType + ", betOn=" + betOn);

            var player = betOn + " SINGLE";
            var betTypeText = "";

            if (rateVal > 0) {

                if (betType == 0) {                    
                    $("#betBoxColor").css('background-color', 'rgb(114, 187, 239)');
                    $("#betBoxColorMob").css('background-color', 'rgb(114, 187, 239)');
                } else if (betType == 1) {
                    betTypeText = "Lay";
                    $("#MatchBetChk").val("L");
                    $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
                    $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
                }

                betTypeText = "Back";
                $("#MatchBetChk").val("K");
                $("#BetTeamindex").val($(this).attr('betOn'));
                $("#MatchTeam").val(betType);
                $("#MatchRate").val(rateVal);

                $("#DisplayBhavName").html(betType);
                $("#Rate1_Odds").val(rateVal);

                //console.log("KRate="+$("#KRate"+betOn).attr("rt"));
                $("#TeamKRate").val("9");
                $("#TeamLRate").val("0");
                $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

                $("#modalTitle").html("LUCKY 7A - " + betType);
                $("#modalRate").html(rateVal);
                $("#betOnModal").val(betOn);
                $("#betTypeModal").val(betType);
                $("#rateValModal").val(rateVal);
                $("#gameId").val(gameId);

                //console.log("rateVal=" + rateVal + ", betOn=" + betOn + ", betType=" + betType + ", player=" + player)
                var $window = $(window);
                var windowsize = $window.width();
                //console.log(windowsize);
                if (windowsize >= 500) {
                    console.log("Lap");
                    $("#betSlipBoxSession").css('display', 'block');
                    $("#DisplayBhavName").html(player);
                    $("#Rate1_Odds").val(rateVal);
                    // document.getElementById("cmdDone").disabled = false;
                    // document.getElementById("cmdDone").style.visibility = "visible";
                    document.getElementById("MatchAmount").value = "";
                    document.getElementById("MatchAmount").readOnly = false;
                    $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
                } else {
                    console.log("Mob");
                    $("#betSlipBoxSessionMob").css('display', 'block');
                    $("#DisplayBhavNameMob").html(player);
                    $("#Rate1_OddsMob").val(rateVal);
                    // document.getElementById("cmdDoneMob").disabled = false;
                    // document.getElementById("cmdDoneMob").style.visibility = "visible";
                    document.getElementById("MatchAmountMob").value = "";
                    document.getElementById("MatchAmountMob").readOnly = false;
                    $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
                }
            }
        }
    });

    var ClearTable = true;
    var DisplayResult = false;
    var MarketID_Old="";

    function getBhavData() {

        $.get(`${API_DOMAIN}/api/odds/Casino/WM.php`, function (data) {

            var ServerTime = "";

            var t = data.ServerTime.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            ServerTime = Date.parse(d);

            var myDate = d;
            var ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
            $("#ServerTime_Formatted").val(ServerTime_Formatted);

            var card1 = '';

            data = (data.WMData);
            //console.log(data);
            if (data.data.hasOwnProperty('t1') == true) {

                var datas = data.data.t1[0];

                if (datas !== null) {
					
					var timer = datas.autotime;
					var timer1 = 0;
					var timer2 = 0;

					if (timer.length == 1) {
						timer1 = 0;
						timer2 = timer[0];
					} else if (timer.length == 2) {
						timer1 = timer[0];
						timer2 = timer[1];
					}
                }
                
                $("#RoundID").html(datas.mid);

                if (datas.C1 == "1")
                    $("#C1").html('<img class="andar-bahar-image" src="../cards/1.png">');
                else
                    $("#C1").html('<img class="andar-bahar-image" src="../cards/' + datas.C1 + '.png">');

                if (datas.C2 == "1")
                    $("#C2").html('<img class="andar-bahar-image" src="../cards/1.png">');
                else
                    $("#C2").html('<img class="andar-bahar-image" src="../cards/' + datas.C2 + '.png">');

                if (datas.C3 == "1")
                    $("#C3").html('<img class="andar-bahar-image" src="../cards/1.png">');
                else
                    $("#C3").html('<img class="andar-bahar-image" src="../cards/' + datas.C3 + '.png">');
                
                $("#Timer").html(timer);

                if (timer > 3  && datas.C1==1 && datas.C2==1 && datas.C3==1) {

                    $("#KRate1").attr("rt", "9");
					$("#kRate2").attr("rt", "9");
					$("#kRate3").attr("rt", "9");
                    $("#kRate4").attr("rt", "9");
                    $("#kRate5").attr("rt", "9");
                    $("#kRate6").attr("rt", "9");
                    $("#kRate7").attr("rt", "9");
                    $("#kRate8").attr("rt", "9");
                    $("#kRate9").attr("rt", "9");
                    $("#kRate0").attr("rt", "9");

                    $("#KRate1").html('<span>1</span>');
                    $("#KRate2").html('<span>2</span>');
                    $("#KRate3").html('<span>3</span>');
                    $("#KRate4").html('<span>4</span>');
                    $("#KRate5").html('<span>5</span>');
                    $("#KRate6").html('<span>6</span>');
                    $("#KRate7").html('<span>7</span>');
                    $("#KRate8").html('<span>8</span>');
                    $("#KRate9").html('<span>9</span>');
                    $("#KRate0").html('<span>0</span>');

                    setBetChk(true);
                } else {

                    $("#KRate1").attr("rt", "0");
					$("#kRate2").attr("rt", "0");
					$("#kRate3").attr("rt", "0");
                    $("#kRate4").attr("rt", "0");
                    $("#kRate5").attr("rt", "0");
                    $("#kRate6").attr("rt", "0");
                    $("#kRate7").attr("rt", "0");
                    $("#kRate8").attr("rt", "0");
                    $("#kRate9").attr("rt", "0");
                    $("#kRate0").attr("rt", "0");

                    $("#KRate1").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>1</span>');
                    $("#KRate2").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>2</span>');
                    $("#KRate3").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>3</span>');
                    $("#KRate4").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>4</span>');
                    $("#KRate5").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>5</span>');
                    $("#KRate6").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>6</span>');
                    $("#KRate7").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>7</span>');
                    $("#KRate8").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>8</span>');
                    $("#KRate9").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>9</span>');
                    $("#KRate0").html('<span><div class="susb-bhav"><img src="/cards/padlock.png" /></div>0</span>');
                    
                    setBetChk(false);
                }

                console.log("MarketID_Old="+MarketID_Old+", MarketID="+datas.mid);

                if (datas.mid != MarketID_Old && ClearTable == true) {
                    DisplayResult = true;
                    MarketID_Old=$("#RoundID").html();
                    setWMBets([]);
                    setTeam1Amt("");
                    setTeam2Amt("");
                    setTeam3Amt("");
                    ClearTable = true;
                }
                //console.log("RoundID="+$("#RoundID").html()+", ClearTable="+ClearTable+", DisplayResult="+DisplayResult);

                if ($("#RoundID").html() != 0 && DisplayResult == true) {
                    DisplayResult = false;
                    getWMResult();
                }

                if(MarketID_Old!=datas.mid)
                    MarketID_Old=datas.mid;

            } else {
                console.log("False");
            }
        });

    }

    useEffect(() => {

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        getWMResult();

        const marketOdsCall = setInterval(() => {
            getBhavData();
        }, 1000);

        return () => clearInterval(marketOdsCall);

    }, []);

    return (
        <>
            <section className="match-content">

                <div className="">
                    <div className="match-box" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                        <div className="mod-header">
                            <div className="select-tv-ico">
                                <span>Worli Matka </span>
                                <span style={{ float: 'right' }}>RoundId : <span id="RoundID"></span></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="col-12 col-md-12" style={{ padding: '0px' }}>
                            <iframe className="live-str" src="https://apis.professorji.in/api/casino-streaming/3054" height="400" width="100%" style={{ backgroundColor: 'black' }}></iframe>
                            <button className="rules-btn">
                                <img style={{ width: '20px' }} src="/images/info.png" />
                            </button>
                            <div className="flipclock">
                                <span className="flipclock-t1 fold" id="Timer">0 0</span>
                            </div>
                            <div className="tp-res-box">
                                <div className="col-md-12 col-12 andr-bhar-res-text andarbahar-res">Card
                                    <div className="rescard andar">
                                        <span id="C1"></span>
                                        <span id="C2"></span>
                                        <span id="C3"></span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="row mr-left-right lucky7-main" style={{ justifyContent: 'center', padding: '0px' }}>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="1" bt="1" id="KRate1" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>1</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="2" bt="2" id="KRate2" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>2</span>
                            </div>
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="3" bt="3" id="KRate3" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>3</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="4" bt="4" id="KRate4" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>4</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="5" bt="5" id="KRate5" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>5</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="6" bt="6" id="KRate6" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>6</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="7" bt="7" id="KRate7" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>7</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="8" bt="8" id="KRate8" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>8</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="9" bt="9" id="KRate9" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>9</span>
                            </div>                            
                        </div>
                        <div className="col-6 col-md-6 lucky7-main-bhav" style={{ padding: '10px' }}>                            
                            <div className="col-12 col-md-12 lucky7-bhav casinoBet" rt="9" beton="0" bt="0" id="KRate0" style={{ padding: '0px', height: '40px' }}>
                                <span><div className="susb-bhav"><img src="/cards/padlock.png" /></div>0</span>
                            </div>                            
                        </div>
                    </div>
                    <div style={{ marginLeft: '0px', marginRight: '0px' }}>
                        <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                            <div className="">
                                <div className="select-tv-ico">
                                    <span>Last Result</span>
                                    <span style={{ float: 'right' }}>
                                        <Link style={{ color: 'rgb(255, 255, 255)' }} to="/Dashboard/WMResult">View All</Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="Result" style={{ color: 'white', backgroundColor: 'rgb(255, 255, 255)', textAlign: 'right', width: '100%' }}>
                            <div>
                                {LastResult.map((row, index) => (
                                    <span
                                        key={index}
                                        className={`game-result ${row.WonBy%2 == 0 ? 'bg-primary' : 'bg-dark'}`}
                                    >
                                        {row.WonBy}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <input name="MatchCode" type="hidden" id="MatchCode" />
                <input name="MatchRate" type="hidden" id="MatchRate" />
                <input name="MatchTeam" type="hidden" id="MatchTeam" />

                <input name="ServerTime_Select" type="hidden" id="ServerTime_Select" />
                <input name="ServerTime_Submit" type="hidden" id="ServerTime_Submit" />

                <input name="DateTimeP" type="hidden" id="DateTimeP" value="1572429898000" />
                <input name="ServerTime_Formatted" type="hidden" id="ServerTime_Formatted" />

                <input name="TeamKRate" type="hidden" id="TeamKRate" />
                <input name="TeamLRate" type="hidden" id="TeamLRate" />
                <input name="BetTeamindex" type="hidden" id="BetTeamindex" />

                <input name="SubmitTimeValue" type="hidden" id="SubmitTimeValue" value="" />

                <input name="MatchBetChk" type="hidden" id="MatchBetChk" value="" />
                <input name="SessionBetChk" type="hidden" id="SessionBetChk" value="" />

                <input name="UserType" id="UserType" type="hidden" value={UserType} />
                <input name="UserName" id="UserName" type="hidden" value={UserName} />

                <input name="MatchMinAmount" type="hidden" id="MatchMinAmount" value="100" />
                <input name="MatchMaxAmount" type="hidden" id="MatchMaxAmount" value="10000" />

                <input name="AmountTime" type="hidden" id="AmountTime" value="" />
                <input name="AmountTimeChk" type="hidden" id="AmountTimeChk" value="" />

                <div className="right-bet-inner">
                    <div id="MatchUnMatchBetaData">
                        <div id="accountView" role="main">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="balance-panel-body">
                                <div className="table-responsive sports-tabel">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr className="heading_user_table" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>
                                                <td>Team</td>
                                                <td>Mode</td>
                                                <td>Rate</td>
                                                <td>Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {WMBets.map((row, index) => (
                                                <tr className="heading_user_table">
                                                    <td>{row.Team}</td>
                                                    <td>{row.Mode === "K" ? "L" : "K"}</td>
                                                    <td>{row.Rate}</td>
                                                    <td>{row.Amount}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>

            <div id="betSidenav" className="betsidenav">
                <a className="closebtn">x</a>
                <section className="right-bet-content">
                    <div className="betSlipBox" id="betSlipBoxSession" style={{ display: 'none' }}>
                        <div className="betBox bet-slip-box">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                            <div className="bet-box_inner" id="betBoxColor" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                                    <div style={{ fontWeight: '700' }} id="DisplayBhavName"></div>
                                </div>
                                <div className="inner-bet-section">
                                    <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                        <div className="items odds">
                                            <div className="stack_input_field numbers-row">
                                                <input disabled="" type="number" className="calProfitLoss odds-input form-control  CommanBtn" value="" id="Rate1_Odds" />
                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="items stake" id=" ">
                                            <div className="stack_input_field numbers-row">
                                                <input type="number" pattern="[0-9]*" step="1" id="MatchAmount" className="calProfitLoss stake-input form-control  CommanBtn" value="0" />

                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bet-btns">
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmount").value = 100; }}>100</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmount").value = 200; }}>200</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmount").value = 500; }}>500</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmount").value = 1000; }}>1K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmount").value = 2000; }}>2K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmount").value = 3000; }}>3K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmount").value = 5000; }}>5K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmount").value = 10000; }}>10K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" " type="button">Clear</button>
                                        </div>
                                    </div>
                                    <div className="bet-box-footer">
                                        <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                        <button className="btn place-bet" type="button" id="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overlay_mobile in"></div>

                </section>
            </div>

            <div className="betSlipBox mobile-bet-box" style={{ position: 'fixed', bottom: '0px', zIndex: '999', display: 'none' }} id="betSlipBoxSessionMob">
                <div className="betBox bet-slip-box">
                    <span id="msg_error"></span>
                    <span id="errmsg"></span>
                    <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                    <div className="bet-box_inner bet-box-inner-mobile" id="betBoxColorMob" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '700' }} id="DisplayBhavNameMob">45 over run SA</div>
                        </div>
                        <div className="inner-bet-section">
                            <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" disabled="" className="calProfitLoss odds-input form-control  CommanBtn" value="9" id="Rate1_OddsMob" />
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" step="1" id="MatchAmountMob" className="calProfitLoss stake-input form-control  CommanBtn" />
                                        <div className="inc plus_btn">
                                            <span className="plus_btns">+</span>
                                            <div className="quantity-button quantity-up">
                                                <i className="fas fa-plus"></i>
                                            </div>
                                        </div>
                                        <div className="dec plus_btn">
                                            <span className="minus_btns">-</span>
                                            <div className="quantity-button quantity-down">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bet-btns">
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmountMob").value = 100; }}>100</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmountMob").value = 200; }}>200</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmountMob").value = 500; }}>500</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmountMob").value = 1000; }}>1K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmountMob").value = 2000; }}>2K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmountMob").value = 3000; }}>3K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmountMob").value = 5000; }}>5K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmountMob").value = 10000; }}>10K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="20000" onClick={() => { document.getElementById("MatchAmountMob").value = 20000; }}>20K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="25000" onClick={() => { document.getElementById("MatchAmountMob").value = 25000; }}>25K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="50000" onClick={() => { document.getElementById("MatchAmountMob").value = 50000; }}>50K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" " type="button">Clear</button>
                                </div>
                            </div>
                            <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                <button className="btn place-bet" type="button" id="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WM;
